import { toZonedTime } from 'date-fns-tz';

import { formatDate } from 'lib/helpers/dateUtils';
import { ia } from 'lib/helpers/utility';

export const formatRangeWithTimezone = (dates, timezone) => {
  if (!dates || !ia(dates) || dates.length !== 2) return null;

  return [
    toZonedTime(new Date(dates[0]), timezone).toISOString(),
    toZonedTime(new Date(dates[1]), timezone).toISOString()
  ];
};

export const formatWithTimezone = (date, timezone) => {
  if (!date || !timezone) return null;

  return toZonedTime(new Date(date), timezone).toISOString();
};

export const formatWithoutTimezone = (date) => {
  if (!date) return null;
  const guessedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return formatDate(new Date(date), guessedTimezone, 'MM/dd/yyyy');
};

export const formatRangeWithoutTimezone = (date) => {
  if (!ia(date, 1)) return null;
  const guessedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return [
    formatDate(new Date(date[0]), guessedTimezone, 'MM/dd/yyyy'),
    formatDate(new Date(date[1]), guessedTimezone, 'MM/dd/yyyy')
  ];
};

export const getDateFormat = ({ isTime, isTimeRange, isSeconds }) => {
  if ((isTime || isTimeRange) && isSeconds) return 'MM/dd/y h:mm:ss a';

  if (isTime || isTimeRange) return 'MM/dd/y h:mm a';

  return 'MM/dd/y';
};
